import { Chip } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import type { ChipProps } from "@mui/material";

type StatusChipProps = {
  label: string;
  color: ChipProps["color"];
};

const StatusChip = ({ label, color }: StatusChipProps) => {
  return (
    <Chip
      label={label}
      size="small"
      variant="outlined"
      icon={<FiberManualRecordIcon />}
      color={color}
    />
  );
};

export default StatusChip;
